import React, { PureComponent } from 'react';
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {
  FlexBar, FlexItem, FlexPadding, SlingHeader,
} from './base/styled';
import StoreContext from './StoreContext';

import './Login.scss';

class Login extends PureComponent {

  constructor(...args) {
    super(...args);
    this.state = {
      username: '',
      password: '',
      error: null,
    };
    this.doLogin = this.doLogin.bind(this);
  }

  async doLogin(store) {
    const { username, password } = this.state;
    const { history } = this.props;
    const opts = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      mode: 'same-origin',
      credentials: 'include',
      body: JSON.stringify({ username, password }),
    };
    const response = await fetch('/sys/login', opts);
    if (response) {
      const json = await response.json();
      if (!json.error) {
        const {
          user,
          dashboards = [],
        } = json;
        store.setCredentials(user, dashboards);
        history.push('/');
        return;
      }
      console.log(json.error);
      this.setState({ error: json.error.message || json.error.toString() });
    }
  }

  render() {
    const { username, password, error } = this.state;
    return (
      <StoreContext.Consumer>
        {store => (
          <div className="Login">
            <SlingHeader />
            <h1>Please Sign In</h1>
            <div className="band">
              <FlexBar>
                <FlexItem>
                  <div className={cn({
                    loginform: true,
                    'error-shake': error,
                  })}
                  >
                    <label htmlFor="email">
                      Email Address
                      <br />
                      <input
                        id="email"
                        tabIndex="#email"
                        name="email"
                        type="text"
                        value={username}
                        onChange={
                          (e) => {
                            this.setState({ username: e.target.value });
                          }
                        }
                      />
                    </label>
                    <label htmlFor="password">
                      Password
                      <br />
                      <input
                        id="password"
                        tabIndex="#pass"
                        name="password"
                        type="password"
                        value={password}
                        onChange={
                          (e) => {
                            this.setState({ password: e.target.value });
                          }
                        }
                        onKeyUp={(e) => {
                          if (e.keyCode === 13 && username && password) {
                            e.preventDefault();
                            this.doLogin(store);
                          }
                        }
                        }
                      />
                    </label>
                    <button
                      type="button"
                      tabIndex="#enter"
                      onClick={(_e) => { this.doLogin(store); }}
                    >
                      SIGN IN
                    </button>
                  </div>
                </FlexItem>
                <FlexPadding />
              </FlexBar>
            </div>
            <SkyLightStateless
              isVisible={error}
              onCloseClicked={() => { this.setState({ error: null }); }}
              title="Login Error"
              transitionDuration={1000}
              dialogStyles={{
                backgroundColor: 'white',
                border: '1px solid black',
                color: 'black',
                minHeight: '250px',
                textAlign: 'center',
              }}
            >
              <div>
                <div>{this.state.error}</div>
                <FlexBar>
                  <FlexPadding />
                  <FlexItem>
                    <button
                      type="button"
                      tabIndex="#enter"
                      onClick={(_e) => { this.setState({ error: null }); }}
                      className="sorry"
                    >
                      OK
                    </button>
                  </FlexItem>
                  <FlexPadding />
                </FlexBar>
              </div>
            </SkyLightStateless>
          </div>)
        }
      </StoreContext.Consumer>
    );
  }
}

Login.propTypes = PropTypes.any.isRequired;

export default Login;
